// extracted by mini-css-extract-plugin
export var bannerContainer = "index-module--bannerContainer--6dHb4";
export var bigBannerBox = "index-module--bigBannerBox--GkmdH";
export var button = "index-module--button--KAjkq";
export var innerBannerbox = "index-module--innerBannerbox--PMGE+";
export var mobileButton = "index-module--mobileButton--NRaI3";
export var nextBtn = "index-module--nextBtn--XMFZS";
export var prevBtn = "index-module--prevBtn--zz0GN";